<template>
  <div class="login-page fn-clear">
    <div class="login-right fn-right">
      <div class="login center-self">
        <div class="logo">
          <img :src="LoginLogo" alt>
        </div>
        <div class="account" :class="{ active: accoutFlag }">
          <i class="account-one" />
          <input
            v-model="account"
            type="text"
            placeholder="请输入用户名"
            maxlength="30"
            @focus="accoutFlag = true"
            @blur="accoutFlag = false"
          >
        </div>
        <div class="password" :class="{ active: passwordFlag }">
          <i class="password-one" />
          <input
            v-model="password"
            type="password"
            placeholder="请输入密码"
            maxlength="30"
            @focus="passwordFlag = true"
            @blur="passwordFlag = false"
          >
        </div>
        <el-button type="primary" @click="login">登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      LoginLogo: require('@/assets/img/login-logo.png'),
      account: '',
      password: '',
      message: '',
      accoutFlag: false,
      passwordFlag: false
    }
  },
  mounted() {},

  methods: {
    async login() {
      const me = this
      if (me.account == '' || me.password == '') {
        me.$message({
          message: '用户名或密码不能为空',
          type: 'warning'
        })
        return false
      }
      const retData = await this.$http.companyLogin({
        username: me.account,
        password: me.password
      })
      if (retData.code == 200) {
        localStorage.setItem('userInfo', JSON.stringify(retData.data.info))
        me.$router.push('/admin/home')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button {
  width: 100%;
  height: 60px;
  border-radius: 10px;
  border: none;
  font-size: 24px;
  color: #ffffff;
  outline: none;
}
.login-page {
  width: 100%;
  height: 100%;
  background: url("http://late-care.tuolele.cn/loginIndex1.png") no-repeat left
    top;
  background-size: 60%;
  .login-right {
    width: 40%;
    height: 100%;
    position: relative;
    .login {
      width: 401px;
      height: 455px;
      .button {
        width: 100%;
        height: 60px;
        background-color: $color_blue;
        border-radius: 10px;
        border: none;
        font-size: 20px;
        color: #ffffff;
        outline: none;
      }
      input {
        width: 90%;
        height: 50px;
        border: none;
        outline: none;
        float: right;
        text-indent: 10px;
      }
      .account,
      .password {
        height: 2px;
        border-bottom: solid 1px #d9d9d9;
        margin-bottom: 25px;
      }
      .account-one,
      .password-one {
        position: absolute;
        top: 12px;
        left: 0;
        width: 24px;
        height: 24px;
      }
      .account {
        &.active {
          .account-one {
            background: url("../assets/img/account-two.png");
            background-size: 100%;
          }
        }
        .account-one {
          background: url("../assets/img/account-one.png");
          background-size: 100%;
        }
      }
      .password {
        &.active {
          .password-one {
            background: url("../assets/img/password-two.png");
            background-size: 100%;
          }
        }
        .password-one {
          background: url("../assets/img/password-one.png");
          background-size: 100%;
        }
      }
      .logo {
        width: 100%;
        img {
          width: 401px;
          height: 107px;
        }
      }
      .account {
        width: 100%;
        height: 60px;
        line-height: 60px;
        margin-top: 55px;
        position: relative;
      }
      .password {
        width: 100%;
        height: 60px;
        line-height: 60px;
        position: relative;
      }
      .message {
        width: 100%;
        height: 60px;
        text-align: center;
        span {
          font-size: 16px;
          color: $color_blue;
        }
      }
    }
  }
}
</style>
